<div class="dx-card wide-card">
    <h4 class="content-block ap-green">H2 Forecast & Steam Reformer Awards: Global, Region and/or Country</h4>
    <div class="content-block">
        <h2-forecast-filters (viewReport)="getH2ForecastByRegion($event)" [regionDataSource]='regionDataSource'
            [dataSource]='dataSource' [showAdditionalDataSwitch]=false></h2-forecast-filters>
        <hr />
    </div>

    <dx-data-grid id="H2ForecastByRegionGrid" class="fixGridHeight" [dataSource]="reportDataSource"
        [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="true"
        [columnAutoWidth]="true" [rowAlternationEnabled]="true">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="false"></dxo-filter-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                    (onClick)="exportExcel($event)">
                </dx-button>
            </dxi-item>
        </dxo-toolbar>

        <dxi-column dataField="reportType" width="80" caption="ReportType"></dxi-column>
        <dxi-column dataField="siteId" caption="SiteId" width="80"></dxi-column>
        <dxi-column dataField="productionFacilityId" caption="Facility Id" width="150"></dxi-column>
        <dxi-column dataField="hycoRegions" width="80" caption="Region"></dxi-column>
        <dxi-column dataField="countryName" width="80" caption="Country"></dxi-column>
        <dxi-column caption="State/Province" dataField="province" width="100"></dxi-column>
        <dxi-column dataField="city" width="100"></dxi-column>
        <dxi-column dataField="owner" caption="Company" width="150"></dxi-column>
        <dxi-column dataField="customer" width="150"></dxi-column>
        <dxi-column dataField="apAmenable" caption="AP Amenable?" [visible]="includeAdditionalData"
            width="90"></dxi-column>
        <dxi-column dataField="estimatedAwardYear" caption="Est Award Year" width="80"></dxi-column>
        <dxi-column dataField="awardYear" width="80"></dxi-column>
        <dxi-column dataField="status" width="85"></dxi-column>
        <dxi-column dataField="hydrogen" caption="Hydrogen (kNm3/h)" width="80"></dxi-column>
        <dxi-column dataField="hydrogenMMSCFD" width="90" caption="Hydrogen (MMSCFD)"></dxi-column>
        <dxi-column dataField="carbonMonoxide" caption="CarbonMonoxide (kNm3/h)" width="80"></dxi-column>
        <dxi-column dataField="carbonMonoxideMMSCFD" width="90" caption="Carbon Monoxide (MMSCFD)"></dxi-column>
        <dxi-column dataField="syngas" caption="Syngas  (kNm3/h)" width="80"></dxi-column>
        <dxi-column dataField="syngasMMSCFD" width="90" caption="Syngas (MMSCFD)"></dxi-column>
        <dxi-column dataField="technologyProvider" caption="Technology Provider" width="80"></dxi-column>
        <dxi-column dataField="feedstock" width="80"></dxi-column>
        <dxi-column dataField="probability" width="90" caption="Probability %"></dxi-column>
        <dxi-column dataField="probabilityWeightedHydrogen" width="90"
            caption="Probability Weighted Hydrogen (kNm3/h)"></dxi-column>
        <dxi-column dataField="probabilityWeightedHydrogenMMSCFD" width="90"
            caption="Probability Weighted Hydrogen (MMSCFD)"></dxi-column>
        <dxi-column dataField="forecastDriver" width="180"></dxi-column>
        <dxi-column dataField="forecastDriverCategory" width="180"></dxi-column>
        <dxi-column dataField="supplyType" width="130"></dxi-column>
        <dxi-column dataField="businessModel" width="100"></dxi-column>
        <dxi-column dataField="sogProbability" caption="% Probability of SOG" width="100"></dxi-column>
        <dxi-column dataField="soeProbabilityWeightedHydrogen" width="90"
            caption="SOE Probability Weighted Hydrogen"></dxi-column>
        <dxi-column dataField="supplyMode" width="100"></dxi-column>
        <dxi-column dataField="notes" width="600"></dxi-column>
        <dxo-summary>
            <dxi-total-item displayFormat="Hydrogen Total: {0}" column="hydrogen" summaryType="sum" alignment="center">
            </dxi-total-item>
            <dxi-total-item column="probabilityWeightedHydrogen" summaryType="sum" alignment="right">
            </dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="false" [closeOnOutsideClick]="false">
</dx-load-panel>